module.exports = __webpack_public_path__ + "static/media/dreambounty.7b8f166d.png";